module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-1200.63a4c3b3.svg";